var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#BCA8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91006 14.9959L7.7071 12.7929C7.31658 12.4024 6.68342 12.4024 6.29289 12.7929C5.90237 13.1834 5.90237 13.8166 6.29289 14.2071L9.29288 17.2071C9.7168 17.631 10.4159 17.5892 10.7863 17.1178L17.7863 9.11786C18.1275 8.68359 18.0521 8.05494 17.6178 7.71372C17.1835 7.37251 16.5549 7.44795 16.2136 7.88222L9.91006 14.9959Z",
    fill: "#16161E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.57b7dcb30eed206dd478e9620c4492fa.svg";
export { ForwardRef as ReactComponent };